import { render, staticRenderFns } from "./ListReport.vue?vue&type=template&id=4b6e0fba&scoped=true&"
import script from "./ListReport.vue?vue&type=script&lang=ts&"
export * from "./ListReport.vue?vue&type=script&lang=ts&"
import style0 from "./ListReport.vue?vue&type=style&index=0&id=4b6e0fba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6e0fba",
  null
  
)

export default component.exports